module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wxc-tab-page weex-ct weex-div",
    style: ({
      height: _vm._px2rem(_vm.tabPageHeight + 'px', 75)
    }),
    attrs: {
      "weex-type": "div"
    }
  }, [_c('div', {
    ref: "tab-page-wrap",
    staticClass: "tab-page-wrap weex-ct weex-div",
    style: ({
      height: _vm._px2rem(_vm.tabPageHeight + 'px', 75)
    }),
    attrs: {
      "prevent-move-event": true,
      "weex-type": "div",
      "data-evt-horizontalpan": ""
    },
    on: {
      "horizontalpan": _vm.startHandler
    }
  }, [_c('div', {
    ref: "tab-container",
    staticClass: "tab-container weex-ct weex-div",
    attrs: {
      "weex-type": "div"
    }
  }, [_vm._t("default", null, {})], 2)]), _vm._v(" "), _c('scroller', {
    ref: "tab-title-list",
    staticClass: "tab-title-list",
    style: ({
      backgroundColor: _vm.tabStyles.bgColor,
      height: _vm._px2rem(_vm.tabStyles.height + 'px', 75),
      top: _vm._px2rem(_vm.tabStyles.top + 'px', 75)
    }),
    attrs: {
      "show-scrollbar": false,
      "scroll-direction": "horizontal",
      "data-spm": _vm.spmC
    }
  }, _vm._l((_vm.tabTitles), function(v, index) {
    return _c('div', {
      key: index,
      ref: 'wxc-tab-title-' + index,
      refInFor: true,
      staticClass: "title-item weex-ct weex-div",
      style: ({
        width: _vm._px2rem(_vm.tabStyles.width + 'px', 75),
        height: _vm._px2rem(_vm.tabStyles.height + 'px', 75),
        backgroundColor: _vm.currentPage == index ? _vm.tabStyles.activeBgColor : _vm.tabStyles.bgColor
      }),
      attrs: {
        "accessible": true,
        "aria-label": ("" + (v.title?v.title:'标签'+index)),
        "weex-type": "div",
        "data-evt-click": ""
      },
      on: {
        "click": _vm.$stopOuterA,
        "weex$tap": function($event) {
          $event.stopPropagation();
          return _vm.setPage(index, v.url)
        }
      }
    }, [(_vm.titleType == 'icon') ? _c('figure', {
      staticClass: " weex-el weex-image",
      style: ({
        width: _vm._px2rem(_vm.tabStyles.iconWidth + 'px', 75),
        height: _vm._px2rem(_vm.tabStyles.iconHeight + 'px', 75)
      }),
      attrs: {
        "src": _vm.currentPage == index ? v.activeIcon : v.icon,
        "data-img-src": _vm.currentPage == index ? v.activeIcon : v.icon,
        "weex-type": "image"
      }
    }) : _vm._e(), _vm._v(" "), _c('p', {
      staticClass: "tab-text weex-el weex-text",
      style: ({
        fontSize: _vm._px2rem(_vm.tabStyles.fontSize + 'px', 75),
        fontWeight: _vm.currentPage == index && _vm.tabStyles.isActiveTitleBold ? 'bold' : 'normal',
        color: _vm.currentPage == index ? _vm.tabStyles.activeTitleColor : _vm.tabStyles.titleColor,
        paddingLeft: _vm._px2rem((_vm.tabStyles.textPaddingLeft ? _vm.tabStyles.textPaddingLeft : 10) + 'px', 75),
        paddingRight: _vm._px2rem((_vm.tabStyles.textPaddingRight ? _vm.tabStyles.textPaddingRight : 10) + 'px', 75)
      }),
      attrs: {
        "weex-type": "text"
      }
    }, [_vm._v(_vm._s(v.title))]), _vm._v(" "), (_vm.tabStyles.hasActiveBottom) ? _c('div', {
      staticClass: "border-bottom weex-ct weex-div",
      style: ({
        width: _vm._px2rem(_vm.tabStyles.activeBottomWidth + 'px', 75),
        left: _vm._px2rem((_vm.tabStyles.width - _vm.tabStyles.activeBottomWidth) / 2 + 'px', 75),
        height: _vm._px2rem(_vm.tabStyles.activeBottomHeight + 'px', 75),
        backgroundColor: _vm.currentPage == index ? _vm.tabStyles.activeBottomColor : 'transparent'
      }),
      attrs: {
        "weex-type": "div"
      }
    }) : _vm._e()])
  }), 0)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-96dd644e", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-96dd644e","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./packages/wxc-tab-page/full-page.vue
// module id = 236
// module chunks = 0 1